declare namespace $ {

	type $mol_view__sub_shm_hitalama_process_view_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_copy__sub_shm_hitalama_process_view_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_copy['sub'] >
	>
	type $mol_button_copy__text_shm_hitalama_process_view_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['running_fiber_trace'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_text__text_shm_hitalama_process_view_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['running_fiber_trace'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__code_sidebar_showed_shm_hitalama_process_view_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_text['code_sidebar_showed'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_process_view_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['call_cards'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_dump_value__value_shm_hitalama_process_view_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['call_args'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_dump_value__expanded_shm_hitalama_process_view_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['args_expanded'] >
		,
		ReturnType< $mol_dump_value['expanded'] >
	>
	type $mol_dump_value__minimal_height_shm_hitalama_process_view_29 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_dump_value['minimal_height'] >
	>
	type $mol_dump_value__value_shm_hitalama_process_view_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['call_result'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_dump_value__expanded_shm_hitalama_process_view_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['result_expanded'] >
		,
		ReturnType< $mol_dump_value['expanded'] >
	>
	type $mol_dump_value__minimal_height_shm_hitalama_process_view_32 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_dump_value['minimal_height'] >
	>
	type $mol_dump_value__value_shm_hitalama_process_view_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['call_error'] >
		,
		ReturnType< $mol_dump_value['value'] >
	>
	type $mol_dump_value__expanded_shm_hitalama_process_view_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_process_view['error_expanded'] >
		,
		ReturnType< $mol_dump_value['expanded'] >
	>
	type $mol_dump_value__minimal_height_shm_hitalama_process_view_35 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_dump_value['minimal_height'] >
	>
	type $mol_view__sub_shm_hitalama_process_view_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_process_view extends $mol_view {
		Title( ): $mol_view
		method_title( ): string
		Method( ): $mol_view
		Head( ): $mol_view
		Stat_total_label( ): $mol_view
		calls_count( ): string
		Stat_total_value( ): $mol_view
		Stat_total( ): $mol_view
		Stat_last_label( ): $mol_view
		status( ): string
		Stat_last_value( ): $mol_view
		Stat_last( ): $mol_view
		Stat_duration_label( ): $mol_view
		duration( ): string
		Stat_duration_value( ): $mol_view
		Stat_duration( ): $mol_view
		Stats( ): $mol_view
		Running_fiber_copy_icon( ): $mol_icon_content_copy
		running_fiber_trace( ): string
		Running_fiber_copy( ): $mol_button_copy
		Running_fiber( ): $mol_text
		Running_fiber_row( ): $mol_view
		running_fiber_visible( ): readonly(any)[]
		promise_str( ): string
		Promise_str( ): $mol_view
		Empty( ): $mol_view
		empty_visible( ): readonly(any)[]
		call_cards( ): readonly(any)[]
		Calls( ): $mol_list
		Call_status( id: any): $mol_view
		Call_name( id: any): $mol_view
		Call_duration( id: any): $mol_view
		Call_head( id: any): $mol_view
		Call_time( id: any): $mol_view
		call_args( id: any): readonly(any)[]
		args_expanded( id: any, next?: boolean ): boolean
		Call_args( id: any): $mol_dump_value
		call_args_visible( id: any): readonly(any)[]
		call_result( id: any): any
		result_expanded( id: any, next?: boolean ): boolean
		Call_result( id: any): $mol_dump_value
		call_result_visible( id: any): readonly(any)[]
		call_error( id: any): any
		error_expanded( id: any, next?: boolean ): boolean
		Call_error( id: any): $mol_dump_value
		call_error_visible( id: any): readonly(any)[]
		host( ): any
		method( ): any
		method_name( ): string
		last( ): $shm_hitalama_process
		state( ): any
		result( ): any
		started_at( ): string
		finished_at( ): string
		error_message( ): string
		sub( ): readonly(any)[]
		Call_card( id: any): $mol_view
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map